export const NAME_CHECKBOX_STYLE = { width: 48 };
